// export const urlChims = "/api/tracks/admin/build/chims";
export const urlChimsList = "/api/tracks/chimneys";
export const urlProfileEditRead = "/api/tracks/chim";
export const urlProfileEditWrite = "/api/tracks/chim/save";
export const urlProfileTopTenSave = "/api/tracks/chim/save/topten";
export const urlProfileLinksSave = "/api/tracks/profile/links";
export const urlProfileContactSend = "/api/tracks/contact";

// export const getChims = axios => axios.get(`${urlChims}`);
export const getChimsList = (axios) => axios.get(`${urlChimsList}`);
export const getChimProfileEdit = (axios, payload) => axios.post(`${urlProfileEditRead}`, payload);
export const getChimProfileSave = (axios, payload) =>
  axios.post(`${urlProfileEditWrite}`, payload, {
    headers: { "content-type": "multipart/form-data" },
  });
export const getChimTopTenSave = (axios, payload) => axios.post(`${urlProfileTopTenSave}`, payload);
export const getChimLinksSave = (axios, payload) => axios.post(`${urlProfileLinksSave}`, payload);
export const getProfileContact = (axios, payload) => axios.post(`${urlProfileContactSend}`, payload);
